import { get } from "../common/remote/base_api";

export const Getuserlogin = (data) => {
  return get(`admin/get-profile/`, data);
};

export const Dashboards= (data) => {
  return get(`admin/get-dashboard-data/`, data);
};
